{
	"backLinkTitle": "Επιστροφή στη Διαχείριση δηλώσεων",
	"invoicedQuantity": "Τιμολογημένη ποσότητα",
	"remainingForDeclarationCreation": "Απομένει για τη δημιουργία δήλωσης",
	"nonTransferableAmount": "Μη διανεμητέο ποσό",
	"btnCreateDeclaration": "+ Δημιουργία δήλωσης",
	"errorMessage": "Αποτυχία φόρτωσης λεπτομερειών υλικού"
}
